export const sliceName = 'participantsOfEvent'

export const participantsLimit = 15
